import { ApiService }                    from '../../app-lite/api/api.service';
import { BusinessIntelligenceService }   from '../../app-lite/business-intelligence/business-intelligence.service';
import { InvoiceModel }                  from '../../app-lite/invoices/models/invoice';
import { JsonService }                   from '../../app-lite/core/services/json.service';
import { PurchaseRequestLogModel }       from '../reports/models/purchase-request.log';
import { QuotesService }                 from '../../app-lite/quotes/quotes.service';
import { SessionService }                from '../../app-lite/sessions/session.service';
import { VehicleRegistrationServiceAjs } from '../vehicle-registrations/vehicle-registration.service.ajs';

import DashboardHtml from './dashboard.html';

export function DashboardStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'DashboardCtrl',
    name       : 'app.dashboard',
    templateUrl: DashboardHtml,
    url        : '/dashboard',
    resolve    : {
      acceptedQuotes                : ( quotesApi : QuotesService ) : ng.IPromise<Array<InvoiceModel>> => quotesApi.getAcceptedQuotes(),
      advertisementUrl              : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dashboard/workshop_ad_link'),
      bookingRequests               : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/event_requests/count'),
      inspectionWidgetStats         : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dashboard/inspection_widget_stats'),
      integrations                  : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      jobs                          : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dashboard/recently_completed', [ 5, 0 ]),
      mechanics                     : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dashboard/mechanics_clocked_in', [ 5, 0 ]),
      notifications                 : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system_notifications'),
      settings                      : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      transactions                  : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dashboard/transaction_logs_index', [ 5, 0 ]),
      tyres                         : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/vehicle_tyre_registrations/outstanding_registrations', [ 5, 0 ]),
      vehicleRegistrationLookups    : ( vehicleRegistrationApi : VehicleRegistrationServiceAjs ) : ng.IPromise<Array<PurchaseRequestLogModel>> => vehicleRegistrationApi.getLookups(),
      businessIntelligenceDashboards: ( $q : ng.IQService, $rootScope : any, businessIntelligenceApi : BusinessIntelligenceService ) : ng.IPromise<any> | ng.IPromise<object> =>
        $rootScope['Company'].hasIntegration('business-intelligence')
          ? businessIntelligenceApi.getDashboards()
          : $q.when({}),
      dealershipWidgetStats: (sessionObjAPI : SessionService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        sessionObjAPI.company().has_dealership
          ? workshopAPI.get('/dashboard/dealership_widget_stats')
          : [],
      widgetStats: ( jsonApi : JsonService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/dashboard/widget_stats', [
        (jsonApi.parse(localStorage.getItem('dashboardTaxSwitch')) === false ? 'false': 'true'),
        (jsonApi.parse(localStorage.getItem('dashboardMTDSwitch')) === false ? 'false': 'true')]
      )
    }
  });
}